﻿let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  TextInput,
  Image,
  Alert,
  Modal,
  FlatList,
  SafeAreaView,
  RefreshControl,
  Dimensions,
  StyleSheet
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Ionicons, MaterialCommunityIcons, FontAwesome5 } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { apiFetch } from '../../utils/apiClient';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';
import useProfile from '../../hooks/useProfile';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width } = Dimensions.get('window');

const CareerEventScreen = ({ navigation, route }) => {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_careereventscreen`;
    apiFetch('/api/data/jobs?sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  const [activeTab, setActiveTab] = useState('discover');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [registeredEvents, setRegisteredEvents] = useState([]);
  const [createdEvents, setCreatedEvents] = useState([]);
  const [networkConnections, setNetworkConnections] = useState([]);
  const [careerGoals, setCareerGoals] = useState([]);

  // Mock data for career events
  const [eventsData, setEventsData] = useState([
    {
      id: 'ce1',
      title: 'Tech Leadership Summit 2025',
      organizer: 'TechCorp International',
      organizerLogo: 'https://via.placeholder.com/100x100/667eea/ffffff?text=TC',
      date: '2025-07-15',
      time: '09:00 AM - 06:00 PM',
      location: 'London Convention Center',
      type: 'Conference',
      category: 'Technology',
      level: 'Senior',
      price: 299,
      currency: 'GBP',
      capacity: 500,
      registered: 342,
      image: 'https://via.placeholder.com/400x200/667eea/ffffff?text=Tech+Summit',
      description: 'Join industry leaders for a comprehensive exploration of technology leadership, innovation strategies, and digital transformation in the modern workplace.',
      speakers: [
        { name: 'Dr. Sarah Chen', role: 'CTO, Microsoft', avatar: 'https://via.placeholder.com/60x60/34C759/ffffff?text=SC' },
        { name: 'James Rodriguez', role: 'VP Engineering, Google', avatar: 'https://via.placeholder.com/60x60/FF9500/ffffff?text=JR' },
        { name: 'Lisa Wang', role: 'Head of AI, Tesla', avatar: 'https://via.placeholder.com/60x60/FF3B30/ffffff?text=LW' }
      ],
      agenda: [
        { time: '09:00', title: 'Registration & Networking Breakfast' },
        { time: '10:00', title: 'Keynote: The Future of Tech Leadership' },
        { time: '11:30', title: 'Panel: Building High-Performance Teams' },
        { time: '14:00', title: 'Workshop: Strategic Decision Making' },
        { time: '16:00', title: 'Networking & Closing Remarks' }
      ],
      skills: ['Leadership', 'Strategy', 'Team Management', 'Innovation'],
      networking: true,
      certificates: true,
      cpdPoints: 8,
      tags: ['Leadership', 'Technology', 'Innovation', 'Strategy'],
      attendeeProfiles: ['Senior Manager', 'Director', 'VP', 'C-Level'],
      benefits: ['Networking opportunities', 'Industry insights', 'Leadership skills', 'Certificate of completion'],
      requirements: ['5+ years management experience', 'Technology background preferred'],
      status: 'upcoming'
    },
    {
      id: 'ce2',
      title: 'Digital Marketing Masterclass',
      organizer: 'Marketing Excellence Institute',
      organizerLogo: 'https://via.placeholder.com/100x100/FF9500/ffffff?text=MEI',
      date: '2025-07-22',
      time: '10:00 AM - 04:00 PM',
      location: 'Manchester Business School',
      type: 'Workshop',
      category: 'Marketing',
      level: 'Intermediate',
      price: 149,
      currency: 'GBP',
      capacity: 50,
      registered: 38,
      image: 'https://via.placeholder.com/400x200/FF9500/ffffff?text=Marketing+Class',
      description: 'Master the latest digital marketing strategies, tools, and techniques to drive business growth and customer engagement in the digital age.',
      speakers: [
        { name: 'Emma Thompson', role: 'Digital Marketing Director', avatar: 'https://via.placeholder.com/60x60/667eea/ffffff?text=ET' },
        { name: 'Michael Chen', role: 'Social Media Expert', avatar: 'https://via.placeholder.com/60x60/34C759/ffffff?text=MC' }
      ],
      agenda: [
        { time: '10:00', title: 'Digital Marketing Fundamentals' },
        { time: '11:30', title: 'Social Media Strategy & Analytics' },
        { time: '13:00', title: 'Lunch & Networking' },
        { time: '14:00', title: 'Content Marketing & SEO' },
        { time: '15:30', title: 'Hands-on Campaign Creation' }
      ],
      skills: ['Digital Marketing', 'SEO', 'Social Media', 'Analytics'],
      networking: true,
      certificates: true,
      cpdPoints: 6,
      tags: ['Marketing', 'Digital', 'SEO', 'Social Media'],
      attendeeProfiles: ['Marketing Manager', 'Digital Specialist', 'Business Owner'],
      benefits: ['Practical skills', 'Industry tools', 'Networking', 'Certificate'],
      requirements: ['Basic marketing knowledge', 'Laptop required'],
      status: 'upcoming'
    },
    {
      id: 'ce3',
      title: 'Financial Planning & Investment Strategies',
      organizer: 'UK Finance Academy',
      organizerLogo: 'https://via.placeholder.com/100x100/34C759/ffffff?text=UFA',
      date: '2025-07-29',
      time: '09:30 AM - 05:30 PM',
      location: 'Edinburgh Financial District',
      type: 'Seminar',
      category: 'Finance',
      level: 'Advanced',
      price: 399,
      currency: 'GBP',
      capacity: 80,
      registered: 65,
      image: 'https://via.placeholder.com/400x200/34C759/ffffff?text=Finance+Seminar',
      description: 'Comprehensive seminar on advanced financial planning, investment strategies, and wealth management for finance professionals.',
      speakers: [
        { name: 'Robert Sterling', role: 'Senior Portfolio Manager', avatar: 'https://via.placeholder.com/60x60/FF3B30/ffffff?text=RS' },
        { name: 'Catherine Mills', role: 'Investment Advisor', avatar: 'https://via.placeholder.com/60x60/5856D6/ffffff?text=CM' }
      ],
      agenda: [
        { time: '09:30', title: 'Market Analysis & Trends' },
        { time: '11:00', title: 'Portfolio Optimization Strategies' },
        { time: '13:00', title: 'Networking Lunch' },
        { time: '14:30', title: 'Risk Management Techniques' },
        { time: '16:00', title: 'Case Studies & Q&A' }
      ],
      skills: ['Financial Analysis', 'Investment Strategy', 'Risk Management', 'Portfolio Management'],
      networking: true,
      certificates: true,
      cpdPoints: 10,
      tags: ['Finance', 'Investment', 'Planning', 'Strategy'],
      attendeeProfiles: ['Financial Advisor', 'Portfolio Manager', 'Investment Analyst'],
      benefits: ['Advanced strategies', 'Professional networking', 'CPD points', 'Certificate'],
      requirements: ['CFA or equivalent qualification', '3+ years finance experience'],
      status: 'upcoming'
    }
  ]);

  // Mock user profile data
  const mockUserProfile = {
    id: 'user1',
    name: 'Alex Johnson',
    title: 'Senior Software Engineer',
    company: 'TechCorp Ltd',
    avatar: 'https://via.placeholder.com/100x100/667eea/ffffff?text=AJ',
    location: 'London, UK',
    experience: '8 years',
    skills: ['JavaScript', 'React', 'Node.js', 'Leadership', 'Project Management'],
    interests: ['Technology', 'Leadership', 'Innovation', 'Startups'],
    careerLevel: 'Senior',
    industry: 'Technology',
    goals: ['Transition to management', 'Learn AI/ML', 'Build professional network'],
    eventsAttended: 12,
    certificatesEarned: 8,
    networkSize: 156,
    cpdPoints: 45
  };

  // Mock career goals data
  const mockCareerGoals = [
    {
      id: 'goal1',
      title: 'Transition to Engineering Management',
      description: 'Develop leadership and management skills to transition from individual contributor to team lead',
      targetDate: '2025-12-31',
      progress: 65,
      relatedSkills: ['Leadership', 'Team Management', 'Strategic Planning'],
      relatedEvents: ['ce1'],
      milestones: [
        { title: 'Complete leadership training', completed: true, date: '2025-03-15' },
        { title: 'Attend management conference', completed: false, date: '2025-07-15' },
        { title: 'Lead a project team', completed: false, date: '2025-09-30' }
      ]
    },
    {
      id: 'goal2',
      title: 'Master AI/Machine Learning',
      description: 'Gain expertise in artificial intelligence and machine learning technologies',
      targetDate: '2026-06-30',
      progress: 30,
      relatedSkills: ['Python', 'Machine Learning', 'Data Science', 'AI'],
      relatedEvents: [],
      milestones: [
        { title: 'Complete online ML course', completed: true, date: '2025-02-28' },
        { title: 'Attend AI conference', completed: false, date: '2025-08-20' },
        { title: 'Implement ML project', completed: false, date: '2026-03-31' }
      ]
    }
  ];

  // Mock network connections
  const mockNetworkConnections = [
    {
      id: 'conn1',
      name: 'Sarah Mitchell',
      title: 'Product Manager',
      company: 'InnovateTech',
      avatar: 'https://via.placeholder.com/60x60/FF9500/ffffff?text=SM',
      connectionDate: '2025-06-10',
      metAt: 'Tech Leadership Summit 2024',
      commonInterests: ['Product Strategy', 'Innovation'],
      lastContact: '2025-06-15',
      status: 'active'
    },
    {
      id: 'conn2',
      name: 'David Chen',
      title: 'Senior Developer',
      company: 'CodeCraft Solutions',
      avatar: 'https://via.placeholder.com/60x60/34C759/ffffff?text=DC',
      connectionDate: '2025-05-22',
      metAt: 'JavaScript Conference 2025',
      commonInterests: ['JavaScript', 'React', 'Open Source'],
      lastContact: '2025-06-08',
      status: 'active'
    }
  ];

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = async () => {
    try {
      // Simulate loading user data
      setUserProfile(mockUserProfile);
      setCareerGoals(mockCareerGoals);
      setNetworkConnections(mockNetworkConnections);
      setRegisteredEvents(['ce1', 'ce2']);
    } catch (error) {
      console.error('Error loading user data:', error);
    }
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await loadUserData();
    setRefreshing(false);
  };

  const handleRegisterEvent = (eventId) => {
    const event = eventsData.find(e => e.id === eventId);
    if (event) {
      Alert.alert(
        'Register for Event',
        `Register for "${event.title}"?\nPrice: £${event.price}`,
        [
          { text: 'Cancel', style: 'cancel' },
          { 
            text: 'Register', 
            onPress: () => {
              setRegisteredEvents([...registeredEvents, eventId]);
              Alert.alert('Success', 'Successfully registered for the event!');
            }
          }
        ]
      );
    }
  };

  const handleEventDetails = (event) => {
    setSelectedEvent(event);
    setModalType('eventDetails');
    setShowModal(true);
  };

  const handleCreateEvent = () => {
    setModalType('createEvent');
    setShowModal(true);
  };

  const handleNetworkProfile = (connection) => {
    setSelectedEvent(connection);
    setModalType('networkProfile');
    setShowModal(true);
  };

  const handleGoalDetails = (goal) => {
    setSelectedEvent(goal);
    setModalType('goalDetails');
    setShowModal(true);
  };

  const filterEvents = () => {
    return eventsData.filter(event => {
      const matchesSearch = String(event.title ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                          String(event.category ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                          String(event.organizer ?? '').toLowerCase().includes(searchQuery.toLowerCase());
      
      const matchesFilters = selectedFilters.length === 0 || 
                           selectedFilters.some(filter => 
                             event.category === filter || 
                             event.type === filter || 
                             event.level === filter
                           );
      
      return matchesSearch && matchesFilters;
    });
  };

  const renderHeader = () => (
    <LinearGradient
      colors={['#667eea', '#764ba2']}
      style={styles.header}
    >
      <SafeAreaView>
        <View style={styles.headerContent}>
          <View style={styles.headerTop}>
            <TouchableOpacity 
              style={styles.backButton}
              onPress={() => navigation.goBack()}
            >
              <Ionicons name="arrow-back" size={24} color="#FFFFFF" />
            </TouchableOpacity>
            <Text style={styles.headerTitle}>Career Events</Text>
            <TouchableOpacity 
              style={styles.profileButton}
              onPress={() => {
                setModalType('profile');
                setShowModal(true);
              }}
            >
              <Image 
                source={{ uri: (userProfile?.avatar && userProfile?.avatar.startsWith('http')) ? userProfile?.avatar : undefined }} 
                style={styles.profileAvatar}
              />
            </TouchableOpacity>
          </View>
          
          <View style={styles.searchContainer}>
            <Ionicons name="search" size={20} color="#8E8E93" style={styles.searchIcon} />
            <TextInput
              style={styles.searchInput}
              placeholder="Search events, skills, or topics..."
              placeholderTextColor="#8E8E93"
              value={searchQuery}
              onChangeText={setSearchQuery}
            />
            <TouchableOpacity 
              style={styles.filterButton}
              onPress={() => {
                setModalType('filters');
                setShowModal(true);
              }}
            >
              <Ionicons name="options" size={20} color="#667eea" />
            </TouchableOpacity>
          </View>
        </View>
      </SafeAreaView>
    </LinearGradient>
  );

  const renderTabBar = () => (
    <View style={styles.tabBar}>
      <TouchableOpacity
        style={[styles.tab, activeTab === 'discover' && styles.activeTab]}
        onPress={() => setActiveTab('discover')}
      >
        <Ionicons 
          name="compass" 
          size={20} 
          color={activeTab === 'discover' ? '#667eea' : '#8E8E93'} 
        />
        <Text style={[styles.tabText, activeTab === 'discover' && styles.activeTabText]}>
          Discover
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[styles.tab, activeTab === 'network' && styles.activeTab]}
        onPress={() => setActiveTab('network')}
      >
        <Ionicons 
          name="people" 
          size={20} 
          color={activeTab === 'network' ? '#667eea' : '#8E8E93'} 
        />
        <Text style={[styles.tabText, activeTab === 'network' && styles.activeTabText]}>
          Network
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[styles.tab, activeTab === 'goals' && styles.activeTab]}
        onPress={() => setActiveTab('goals')}
      >
        <Ionicons 
          name="trophy" 
          size={20} 
          color={activeTab === 'goals' ? '#667eea' : '#8E8E93'} 
        />
        <Text style={[styles.tabText, activeTab === 'goals' && styles.activeTabText]}>
          Goals
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[styles.tab, activeTab === 'myevents' && styles.activeTab]}
        onPress={() => setActiveTab('myevents')}
      >
        <Ionicons 
          name="calendar" 
          size={20} 
          color={activeTab === 'myevents' ? '#667eea' : '#8E8E93'} 
        />
        <Text style={[styles.tabText, activeTab === 'myevents' && styles.activeTabText]}>
          My Events
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[styles.tab, activeTab === 'analytics' && styles.activeTab]}
        onPress={() => setActiveTab('analytics')}
      >
        <Ionicons 
          name="bar-chart" 
          size={20} 
          color={activeTab === 'analytics' ? '#667eea' : '#8E8E93'} 
        />
        <Text style={[styles.tabText, activeTab === 'analytics' && styles.activeTabText]}>
          Analytics
        </Text>
      </TouchableOpacity>
    </View>
  );

  const renderDiscoverTab = () => (
    <ScrollView 
      style={styles.content}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      <View style={styles.sectionHeader}>
        <Text style={styles.sectionTitle}>Recommended Events</Text>
        <Text style={styles.sectionSubtitle}>Based on your profile and goals</Text>
      </View>

      {filterEvents().map((event) => (
        <TouchableOpacity
          key={event.id}
          style={styles.eventCard}
          onPress={() => handleEventDetails(event)}
        >
          <Image source={{ uri: (event.image && typeof event.image=="string" && event.image.startsWith("http")) ? event.image : undefined }} style={styles.eventImage} />
          
          <View style={styles.eventContent}>
            <View style={styles.eventHeader}>
              <View style={styles.eventBadges}>
                <View style={[styles.badge, styles.typeBadge]}>
                  <Text style={styles.badgeText}>{event.type}</Text>
                </View>
                <View style={[styles.badge, styles.levelBadge]}>
                  <Text style={styles.badgeText}>{event.level}</Text>
                </View>
              </View>
              <Text style={styles.eventPrice}>£{event.price}</Text>
            </View>

            <Text style={styles.eventTitle}>{event.title}</Text>
            <Text style={styles.eventOrganizer}>{event.organizer}</Text>

            <View style={styles.eventDetails}>
              <View style={styles.eventDetail}>
                <Ionicons name="calendar-outline" size={16} color="#8E8E93" />
                <Text style={styles.eventDetailText}>{event.date}</Text>
              </View>
              <View style={styles.eventDetail}>
                <Ionicons name="time-outline" size={16} color="#8E8E93" />
                <Text style={styles.eventDetailText}>{event.time}</Text>
              </View>
              <View style={styles.eventDetail}>
                <Ionicons name="location-outline" size={16} color="#8E8E93" />
                <Text style={styles.eventDetailText}>{event.location}</Text>
              </View>
            </View>

            <View style={styles.eventSkills}>
              {event.skills.slice(0, 3).map((skill, index) => (
                <View key={index} style={styles.skillTag}>
                  <Text style={styles.skillTagText}>{skill}</Text>
                </View>
              ))}
              {event.skills.length > 3 && (
                <Text style={styles.moreSkills}>+{event.skills.length - 3} more</Text>
              )}
            </View>

            <View style={styles.eventFooter}>
              <View style={styles.eventStats}>
                <Ionicons name="people-outline" size={16} color="#8E8E93" />
                <Text style={styles.eventStatsText}>
                  {event.registered}/{event.capacity} registered
                </Text>
              </View>
              
              <TouchableOpacity
                style={[
                  styles.registerButton,
                  registeredEvents.includes(event.id) && styles.registeredButton
                ]}
                onPress={() => handleRegisterEvent(event.id)}
                disabled={registeredEvents.includes(event.id)}
              >
                <Text style={[
                  styles.registerButtonText,
                  registeredEvents.includes(event.id) && styles.registeredButtonText
                ]}>
                  {registeredEvents.includes(event.id) ? 'Registered' : 'Register'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </TouchableOpacity>
      ))}
    </ScrollView>
  );

  const renderNetworkTab = () => (
    <ScrollView 
      style={styles.content}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      <View style={styles.networkStats}>
        <View style={styles.networkStat}>
          <Text style={styles.networkStatNumber}>{userProfile?.networkSize || 0}</Text>
          <Text style={styles.networkStatLabel}>Connections</Text>
        </View>
        <View style={styles.networkStat}>
          <Text style={styles.networkStatNumber}>{networkConnections.length}</Text>
          <Text style={styles.networkStatLabel}>Recent</Text>
        </View>
        <View style={styles.networkStat}>
          <Text style={styles.networkStatNumber}>{userProfile?.eventsAttended || 0}</Text>
          <Text style={styles.networkStatLabel}>Events</Text>
        </View>
      </View>

      <View style={styles.sectionHeader}>
        <Text style={styles.sectionTitle}>Recent Connections</Text>
        <TouchableOpacity>
          <Text style={styles.seeAllText}>See All</Text>
        </TouchableOpacity>
      </View>

      {networkConnections.map((connection) => (
        <TouchableOpacity
          key={connection.id}
          style={styles.connectionCard}
          onPress={() => handleNetworkProfile(connection)}
        >
          <Image source={{ uri: (connection.avatar && connection.avatar.startsWith('http')) ? connection.avatar : undefined }} style={styles.connectionAvatar} />
          
          <View style={styles.connectionInfo}>
            <Text style={styles.connectionName}>{connection.name}</Text>
            <Text style={styles.connectionTitle}>{connection.title}</Text>
            <Text style={styles.connectionCompany}>{connection.company}</Text>
            
            <View style={styles.connectionMeta}>
              <Text style={styles.connectionMetaText}>
                Met at {connection.metAt}
              </Text>
              <Text style={styles.connectionDate}>
                {connection.connectionDate}
              </Text>
            </View>
          </View>

          <TouchableOpacity style={styles.messageButton}>
            <Ionicons name="chatbubble-outline" size={20} color="#667eea" />
          </TouchableOpacity>
        </TouchableOpacity>
      ))}
    </ScrollView>
  );

  const renderGoalsTab = () => (
    <ScrollView 
      style={styles.content}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      <View style={styles.goalsHeader}>
        <Text style={styles.sectionTitle}>Career Goals</Text>
        <TouchableOpacity 
          style={styles.addGoalButton}
          onPress={() => {
            setModalType('addGoal');
            setShowModal(true);
          }}
        >
          <Ionicons name="add" size={20} color="#FFFFFF" />
          <Text style={styles.addGoalButtonText}>Add Goal</Text>
        </TouchableOpacity>
      </View>

      {careerGoals.map((goal) => (
        <TouchableOpacity
          key={goal.id}
          style={styles.goalCard}
          onPress={() => handleGoalDetails(goal)}
        >
          <View style={styles.goalHeader}>
            <Text style={styles.goalTitle}>{goal.title}</Text>
            <Text style={styles.goalProgress}>{goal.progress}%</Text>
          </View>

          <View style={styles.progressBarContainer}>
            <View 
              style={[styles.progressBar, { width: `${goal.progress}%` }]}
            />
          </View>

          <Text style={styles.goalDescription} numberOfLines={2}>
            {goal.description}
          </Text>

          <View style={styles.goalMeta}>
            <View style={styles.goalDetail}>
              <Ionicons name="calendar-outline" size={16} color="#8E8E93" />
              <Text style={styles.goalDetailText}>Target: {goal.targetDate}</Text>
            </View>
            <View style={styles.goalDetail}>
              <Ionicons name="checkmark-circle-outline" size={16} color="#8E8E93" />
              <Text style={styles.goalDetailText}>
                {goal.milestones.filter(m => m.completed).length}/{goal.milestones.length} milestones
              </Text>
            </View>
          </View>

          <View style={styles.goalSkills}>
            {goal.relatedSkills.slice(0, 3).map((skill, index) => (
              <View key={index} style={styles.skillTag}>
                <Text style={styles.skillTagText}>{skill}</Text>
              </View>
            ))}
          </View>
        </TouchableOpacity>
      ))}
    </ScrollView>
  );

  const renderMyEventsTab = () => (
    <ScrollView 
      style={styles.content}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      <View style={styles.myEventsHeader}>
        <Text style={styles.sectionTitle}>My Events</Text>
        <TouchableOpacity 
          style={styles.createEventButton}
          onPress={handleCreateEvent}
        >
          <Ionicons name="add" size={20} color="#FFFFFF" />
          <Text style={styles.createEventButtonText}>Create Event</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.eventTabs}>
        <TouchableOpacity style={styles.eventTab}>
          <Text style={styles.eventTabText}>Registered ({registeredEvents.length})</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.eventTab}>
          <Text style={styles.eventTabText}>Created ({createdEvents.length})</Text>
        </TouchableOpacity>
      </View>

      {eventsData
        .filter(event => registeredEvents.includes(event.id))
        .map((event) => (
          <TouchableOpacity
            key={event.id}
            style={styles.myEventCard}
            onPress={() => handleEventDetails(event)}
          >
            <Image source={{ uri: (event.image && typeof event.image=="string" && event.image.startsWith("http")) ? event.image : undefined }} style={styles.myEventImage} />
            
            <View style={styles.myEventContent}>
              <Text style={styles.myEventTitle}>{event.title}</Text>
              <Text style={styles.myEventDate}>{event.date} • {event.time}</Text>
              <Text style={styles.myEventLocation}>{event.location}</Text>
              
              <View style={styles.myEventActions}>
                <TouchableOpacity style={styles.myEventAction}>
                  <Ionicons name="calendar-outline" size={16} color="#667eea" />
                  <Text style={styles.myEventActionText}>Add to Calendar</Text>
                </TouchableOpacity>
                <TouchableOpacity style={styles.myEventAction}>
                  <Ionicons name="share-outline" size={16} color="#667eea" />
                  <Text style={styles.myEventActionText}>Share</Text>
                </TouchableOpacity>
              </View>
            </View>
          </TouchableOpacity>
        ))}
    </ScrollView>
  );

  const renderAnalyticsTab = () => (
    <ScrollView 
      style={styles.content}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      <View style={styles.analyticsGrid}>
        <View style={styles.analyticsCard}>
          <Ionicons name="calendar" size={32} color="#667eea" />
          <Text style={styles.analyticsNumber}>{userProfile?.eventsAttended || 0}</Text>
          <Text style={styles.analyticsLabel}>Events Attended</Text>
        </View>
        
        <View style={styles.analyticsCard}>
          <Ionicons name="ribbon" size={32} color="#34C759" />
          <Text style={styles.analyticsNumber}>{userProfile?.certificatesEarned || 0}</Text>
          <Text style={styles.analyticsLabel}>Certificates</Text>
        </View>
        
        <View style={styles.analyticsCard}>
          <Ionicons name="people" size={32} color="#FF9500" />
          <Text style={styles.analyticsNumber}>{userProfile?.networkSize || 0}</Text>
          <Text style={styles.analyticsLabel}>Network Size</Text>
        </View>
        
        <View style={styles.analyticsCard}>
          <Ionicons name="trophy" size={32} color="#FF3B30" />
          <Text style={styles.analyticsNumber}>{userProfile?.cpdPoints || 0}</Text>
          <Text style={styles.analyticsLabel}>CPD Points</Text>
        </View>
      </View>

      <View style={styles.chartSection}>
        <Text style={styles.chartTitle}>Monthly Activity</Text>
        <View style={styles.chartPlaceholder}>
          <Ionicons name="bar-chart" size={48} color="#C7C7CC" />
          <Text style={styles.chartPlaceholderText}>Activity Chart</Text>
        </View>
      </View>

      <View style={styles.skillsProgress}>
        <Text style={styles.sectionTitle}>Skills Development</Text>
        {userProfile?.skills.slice(0, 5).map((skill, index) => (
          <View key={index} style={styles.skillProgress}>
            <Text style={styles.skillName}>{skill}</Text>
            <View style={styles.skillProgressBar}>
              <View 
                style={[
                  styles.skillProgressFill, 
                  { width: `${Math.random() * 40 + 60}%` }
                ]} 
              />
            </View>
          </View>
        ))}
      </View>
    </ScrollView>
  );

  const renderEventDetailsModal = () => {
    if (!selectedEvent) return null;

    return (
      <View style={styles.modalContent}>
        <ScrollView>
          <Image source={{ uri: (selectedEvent.image && typeof selectedEvent.image=="string" && selectedEvent.image.startsWith("http")) ? selectedEvent.image : undefined }} style={styles.modalEventImage} />
          
          <View style={styles.modalEventContent}>
            <View style={styles.modalEventHeader}>
              <TouchableOpacity
                style={styles.modalCloseButton}
                onPress={() => setShowModal(false)}
              >
                <Ionicons name="close" size={24} color="#8E8E93" />
              </TouchableOpacity>
            </View>

            <Text style={styles.modalEventTitle}>{selectedEvent.title}</Text>
            <Text style={styles.modalEventOrganizer}>{selectedEvent.organizer}</Text>

            <View style={styles.modalEventDetails}>
              <View style={styles.modalEventDetail}>
                <Ionicons name="calendar" size={20} color="#667eea" />
                <Text style={styles.modalEventDetailText}>{selectedEvent.date}</Text>
              </View>
              <View style={styles.modalEventDetail}>
                <Ionicons name="time" size={20} color="#667eea" />
                <Text style={styles.modalEventDetailText}>{selectedEvent.time}</Text>
              </View>
              <View style={styles.modalEventDetail}>
                <Ionicons name="location" size={20} color="#667eea" />
                <Text style={styles.modalEventDetailText}>{selectedEvent.location}</Text>
              </View>
              <View style={styles.modalEventDetail}>
                <Ionicons name="pricetag" size={20} color="#667eea" />
                <Text style={styles.modalEventDetailText}>£{selectedEvent.price}</Text>
              </View>
            </View>

            <Text style={styles.modalEventDescription}>{selectedEvent.description}</Text>

            <View style={styles.modalSection}>
              <Text style={styles.modalSectionTitle}>Speakers</Text>
              {selectedEvent.speakers?.map((speaker, index) => (
                <View key={index} style={styles.speakerItem}>
                  <Image source={{ uri: (speaker.avatar && speaker.avatar.startsWith('http')) ? speaker.avatar : undefined }} style={styles.speakerAvatar} />
                  <View>
                    <Text style={styles.speakerName}>{speaker.name}</Text>
                    <Text style={styles.speakerRole}>{speaker.role}</Text>
                  </View>
                </View>
              ))}
            </View>

            <View style={styles.modalSection}>
              <Text style={styles.modalSectionTitle}>Agenda</Text>
              {selectedEvent.agenda?.map((item, index) => (
                <View key={index} style={styles.agendaItem}>
                  <Text style={styles.agendaTime}>{item.time}</Text>
                  <Text style={styles.agendaTitle}>{item.title}</Text>
                </View>
              ))}
            </View>

            <TouchableOpacity
              style={[
                styles.modalRegisterButton,
                registeredEvents.includes(selectedEvent.id) && styles.modalRegisteredButton
              ]}
              onPress={() => handleRegisterEvent(selectedEvent.id)}
              disabled={registeredEvents.includes(selectedEvent.id)}
            >
              <Text style={[
                styles.modalRegisterButtonText,
                registeredEvents.includes(selectedEvent.id) && styles.modalRegisteredButtonText
              ]}>
                {registeredEvents.includes(selectedEvent.id) ? 'Registered' : `Register - £${selectedEvent.price}`}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </View>
    );
  };

  const renderModal = () => {
    switch (modalType) {
      case 'eventDetails':
        return renderEventDetailsModal();
      case 'profile':
        return (
          <View style={styles.modalContent}>
            <View style={styles.modalHeader}>
              <TouchableOpacity
                style={styles.modalCloseButton}
                onPress={() => setShowModal(false)}
              >
                <Ionicons name="close" size={24} color="#8E8E93" />
              </TouchableOpacity>
              <Text style={styles.modalTitle}>Profile</Text>
            </View>
            <ScrollView style={styles.modalBody}>
              <View style={styles.profileSection}>
                <Image source={{ uri: (userProfile?.avatar && userProfile?.avatar.startsWith('http')) ? userProfile?.avatar : undefined }} style={styles.profileImage} />
                <Text style={styles.profileName}>{userProfile?.name}</Text>
                <Text style={styles.profileTitle}>{userProfile?.title}</Text>
                <Text style={styles.profileCompany}>{userProfile?.company}</Text>
              </View>
            </ScrollView>
          </View>
        );
      default:
        return null;
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'discover':
        return renderDiscoverTab();
      case 'network':
        return renderNetworkTab();
      case 'goals':
        return renderGoalsTab();
      case 'myevents':
        return renderMyEventsTab();
      case 'analytics':
        return renderAnalyticsTab();
      default:
        return renderDiscoverTab();
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      {renderHeader()}
      {renderTabBar()}
      {renderContent()}
      
      <Modal
        visible={showModal}
        animationType="slide"
        presentationStyle="pageSheet"
      >
        {renderModal()}
      </Modal>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F8F9FA',
  },
  header: {
    paddingBottom: 20,
  },
  headerContent: {
    paddingHorizontal: 20,
  },
  headerTop: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  profileButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    overflow: 'hidden',
  },
  profileAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
  },
  searchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    paddingHorizontal: 16,
    height: 48,
  },
  searchIcon: {
    marginRight: 12,
  },
  searchInput: {
    flex: 1,
    fontSize: 16,
    color: '#1C1C1E',
  },
  filterButton: {
    padding: 8,
    marginLeft: 8,
  },
  tabBar: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5EA',
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 8,
  },
  activeTab: {
    borderBottomWidth: 2,
    borderBottomColor: '#667eea',
  },
  tabText: {
    fontSize: 12,
    color: '#8E8E93',
    marginTop: 4,
  },
  activeTabText: {
    color: '#667eea',
    fontWeight: '600',
  },
  content: {
    flex: 1,
    paddingHorizontal: 20,
  },
  sectionHeader: {
    marginVertical: 20,
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  sectionSubtitle: {
    fontSize: 16,
    color: '#8E8E93',
  },
  eventCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
  },
  eventImage: {
    width: '100%',
    height: 200,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  eventContent: {
    padding: 16,
  },
  eventHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  eventBadges: {
    flexDirection: 'row',
    gap: 8,
  },
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  typeBadge: {
    backgroundColor: '#E3F2FD',
  },
  levelBadge: {
    backgroundColor: '#F3E5F5',
  },
  badgeText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#667eea',
  },
  eventPrice: {
    fontSize: 18,
    fontWeight: '700',
    color: '#34C759',
  },
  eventTitle: {
    fontSize: 20,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  eventOrganizer: {
    fontSize: 16,
    color: '#8E8E93',
    marginBottom: 12,
  },
  eventDetails: {
    marginBottom: 12,
  },
  eventDetail: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  eventDetailText: {
    fontSize: 14,
    color: '#8E8E93',
    marginLeft: 8,
  },
  eventSkills: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 16,
  },
  skillTag: {
    backgroundColor: '#F2F2F7',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  skillTagText: {
    fontSize: 12,
    color: '#3C3C43',
    fontWeight: '500',
  },
  moreSkills: {
    fontSize: 12,
    color: '#8E8E93',
    alignSelf: 'center',
  },
  eventFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  eventStats: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  eventStatsText: {
    fontSize: 14,
    color: '#8E8E93',
    marginLeft: 6,
  },
  registerButton: {
    backgroundColor: '#667eea',
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 20,
  },
  registeredButton: {
    backgroundColor: '#34C759',
  },
  registerButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  registeredButtonText: {
    color: '#FFFFFF',
  },
  networkStats: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    marginVertical: 20,
  },
  networkStat: {
    alignItems: 'center',
  },
  networkStatNumber: {
    fontSize: 24,
    fontWeight: '700',
    color: '#667eea',
  },
  networkStatLabel: {
    fontSize: 14,
    color: '#8E8E93',
    marginTop: 4,
  },
  seeAllText: {
    fontSize: 16,
    color: '#667eea',
    fontWeight: '500',
  },
  connectionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  connectionAvatar: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 12,
  },
  connectionInfo: {
    flex: 1,
  },
  connectionName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
  },
  connectionTitle: {
    fontSize: 14,
    color: '#667eea',
    marginTop: 2,
  },
  connectionCompany: {
    fontSize: 14,
    color: '#8E8E93',
    marginTop: 2,
  },
  connectionMeta: {
    marginTop: 4,
  },
  connectionMetaText: {
    fontSize: 12,
    color: '#8E8E93',
  },
  connectionDate: {
    fontSize: 12,
    color: '#8E8E93',
  },
  messageButton: {
    padding: 8,
  },
  goalsHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 20,
  },
  addGoalButton: {
    backgroundColor: '#667eea',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
  },
  addGoalButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
    marginLeft: 6,
  },
  goalCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    marginBottom: 16,
  },
  goalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  goalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1C1C1E',
    flex: 1,
  },
  goalProgress: {
    fontSize: 16,
    fontWeight: '700',
    color: '#667eea',
  },
  progressBarContainer: {
    height: 8,
    backgroundColor: '#F2F2F7',
    borderRadius: 4,
    marginBottom: 12,
  },
  progressBar: {
    height: 8,
    backgroundColor: '#667eea',
    borderRadius: 4,
  },
  goalDescription: {
    fontSize: 14,
    color: '#8E8E93',
    lineHeight: 20,
    marginBottom: 12,
  },
  goalMeta: {
    marginBottom: 12,
  },
  goalDetail: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  goalDetailText: {
    fontSize: 14,
    color: '#8E8E93',
    marginLeft: 8,
  },
  goalSkills: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  myEventsHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 20,
  },
  createEventButton: {
    backgroundColor: '#667eea',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
  },
  createEventButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
    marginLeft: 6,
  },
  eventTabs: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    padding: 4,
    marginBottom: 20,
  },
  eventTab: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 12,
  },
  eventTabText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#8E8E93',
  },
  myEventCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    marginBottom: 12,
    flexDirection: 'row',
  },
  myEventImage: {
    width: 80,
    height: 80,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
  },
  myEventContent: {
    flex: 1,
    padding: 12,
  },
  myEventTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  myEventDate: {
    fontSize: 14,
    color: '#667eea',
    marginBottom: 2,
  },
  myEventLocation: {
    fontSize: 14,
    color: '#8E8E93',
    marginBottom: 8,
  },
  myEventActions: {
    flexDirection: 'row',
    gap: 16,
  },
  myEventAction: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  myEventActionText: {
    fontSize: 12,
    color: '#667eea',
    marginLeft: 4,
  },
  analyticsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginVertical: 20,
  },
  analyticsCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    alignItems: 'center',
    width: (width - 52) / 2,
  },
  analyticsNumber: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1C1C1E',
    marginTop: 8,
  },
  analyticsLabel: {
    fontSize: 14,
    color: '#8E8E93',
    marginTop: 4,
    textAlign: 'center',
  },
  chartSection: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    marginBottom: 20,
  },
  chartTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 16,
  },
  chartPlaceholder: {
    height: 200,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F8F9FA',
    borderRadius: 12,
  },
  chartPlaceholderText: {
    fontSize: 16,
    color: '#C7C7CC',
    marginTop: 8,
  },
  skillsProgress: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
  },
  skillProgress: {
    marginBottom: 16,
  },
  skillName: {
    fontSize: 16,
    fontWeight: '500',
    color: '#1C1C1E',
    marginBottom: 8,
  },
  skillProgressBar: {
    height: 8,
    backgroundColor: '#F2F2F7',
    borderRadius: 4,
  },
  skillProgressFill: {
    height: 8,
    backgroundColor: '#667eea',
    borderRadius: 4,
  },
  modalContent: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  modalEventImage: {
    width: '100%',
    height: 250,
  },
  modalEventContent: {
    padding: 20,
  },
  modalEventHeader: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 20,
  },
  modalCloseButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F2F2F7',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalEventTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 8,
  },
  modalEventOrganizer: {
    fontSize: 18,
    color: '#667eea',
    marginBottom: 20,
  },
  modalEventDetails: {
    marginBottom: 20,
  },
  modalEventDetail: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  modalEventDetailText: {
    fontSize: 16,
    color: '#1C1C1E',
    marginLeft: 12,
  },
  modalEventDescription: {
    fontSize: 16,
    color: '#3C3C43',
    lineHeight: 24,
    marginBottom: 24,
  },
  modalSection: {
    marginBottom: 24,
  },
  modalSectionTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1C1C1E',
    marginBottom: 16,
  },
  speakerItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  speakerAvatar: {
    width: 50,
    height: 50,
    borderRadius: 25,
    marginRight: 12,
  },
  speakerName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1C1C1E',
  },
  speakerRole: {
    fontSize: 14,
    color: '#8E8E93',
  },
  agendaItem: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  agendaTime: {
    fontSize: 14,
    fontWeight: '600',
    color: '#667eea',
    width: 60,
  },
  agendaTitle: {
    fontSize: 14,
    color: '#1C1C1E',
    flex: 1,
  },
  modalRegisterButton: {
    backgroundColor: '#667eea',
    borderRadius: 12,
    paddingVertical: 16,
    alignItems: 'center',
    marginTop: 20,
  },
  modalRegisteredButton: {
    backgroundColor: '#34C759',
  },
  modalRegisterButtonText: {
    fontSize: 18,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  modalRegisteredButtonText: {
    color: '#FFFFFF',
  },
  modalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5EA',
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#1C1C1E',
  },
  modalBody: {
    flex: 1,
    padding: 20,
  },
  profileSection: {
    alignItems: 'center',
    marginBottom: 24,
  },
  profileImage: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 16,
  },
  profileName: {
    fontSize: 24,
    fontWeight: '700',
    color: '#1C1C1E',
    marginBottom: 4,
  },
  profileTitle: {
    fontSize: 18,
    color: '#667eea',
    marginBottom: 4,
  },
  profileCompany: {
    fontSize: 16,
    color: '#8E8E93',
  },
});

export default CareerEventScreen;
